export default __webpack_public_path__ + "static/media/fNeutral22.b7f48c3f.png";